/**
 * filter
 * @name lpadAuto
 *
 * @description
 * filter that append on the left a '0' when number is less than 10
 *
 * @param {input} string usually, the number to be auto lpaded
 *
 * @example
 *  {{$ctrl.number | lpadAuto}}
 *  $filter(this.number)(number);
 *
 * @return {string} a number filled with a '0' on the left when input number is less than 10 ex: 5 -> 05; 10 -> 10
 *
*/

export default function() {
  return function(input) {
    if(parseInt(input) < 10){
      return  '0'+input;
    }
    return input.toString();
  };
}



// WEBPACK FOOTER //
// ./client/app/common/filters/lpadAuto.js